import { render, staticRenderFns } from "./PieEchartTicket.vue?vue&type=template&id=06c575e3"
import script from "./PieEchartTicket.vue?vue&type=script&lang=js"
export * from "./PieEchartTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports